import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import { ServiceManager } from '@jutro/services';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ContactLinkComponent } from 'gw-capability-claim-react';
import { withRouter, Link } from 'react-router-dom';
import metadata from './UserSelectionPageAfterDeactivation.metadata.json5';
import styles from './AgentListView.module.scss';
import {
    Button,
} from '@jutro/components';
import FNOLService from '../../../../../../common/capabilities/gw-capability-fnol/services/FNOLService';
import { useAuthentication } from 'gw-digital-auth-react';
import { SasriaAgentSignupService } from '../../../../../../common/capabilities/gw-capability-agentsignup-sasria';

function UserSelectionPageAfterDeactivation(props) {
    const {
        history: { location: { state } },
    } = props;

    const { location, history } = props;

    const [userTable, setuserTable] = useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const [deactivatedEmail, setDeactivatedEmail] = useState();
    const localeService = ServiceManager.getService('locale-service');
    const userData = useAuthentication();

    useEffect(() => {
        const deactivatedUser = _.get(state, 'deactivatedUser');
        setDeactivatedEmail(deactivatedUser)
    }, [deactivatedEmail]);

    const processUserDataData = useCallback(
        (userData) => {
            if (!_.isEmpty(userData)) {
                let userArrayResult = userData;
                userArrayResult = userArrayResult.map((userInfo) => {
                    const users = {
                        firstname: userInfo.name.givenName,
                        lastname: userInfo.name.familyName,
                        emailaddress: userInfo.emails[0].value
                    };

                    return users;
                });
                return userArrayResult;
            }
            return [];
        },
    );

    const getUsers = useCallback(
        () => {
            const userPromise = SasriaAgentSignupService.getUserSummary(userData.user_name);
            return userPromise
                .then((responseData) => {
                    const data = processUserDataData(responseData);
                    setuserTable(data);
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [processUserDataData]
    );



    const loadUserData = useCallback(
        () => {
            return getUsers();
        },
        []
    );

    useEffect(() => {
        loadUserData();
    }, []);


    const hanleAddUserForopenClaims = useCallback(
        (email, firstname, lastname) => {
            return SasriaAgentSignupService.changeMainContactOnDeactivation_EXT(deactivatedEmail, firstname, lastname, email)
                .then((resp) => {
                    if (resp.error == null) {
                        history.push('/agentsignupviewlist');
                    }
                })
        },
        [history, deactivatedEmail],
    )




    const addUser = useCallback(
        (item, index, property) => {
            const _emailAddress = item.emailaddress;
            const _firstName = item.firstname;
            const _lastname = item.lastname;
            return (
                <Button onClick={() => {
                    hanleAddUserForopenClaims(_emailAddress, _firstName, _lastname);
                }}
                >
                    {'Add'}
                </Button>
            );
        }
    );


    const overrides = {
        claimListTableLoader: {
            loaded: !isLoading
        },
        claimTable: {
            data: userTable,
            visible: !isLoading
        },

        globalizationChooserField: {
            onLanguageValueChange: localeService.saveLanguage,
            languageValue: localeService.getStoredLanguage()
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            addUser: addUser


        }
    };
    return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);

}

export default withRouter(UserSelectionPageAfterDeactivation);